<lib-filters-component [filters_options]="filter_service.filtersType"></lib-filters-component>
<h2>{{ wCupName | transloco }}</h2>
<app-wa-table
  [isSortableFunc]="sortClass"
  [showCondition]="true"
  [headers]="headers"
  [isDataLoading]="false"
  [areMoreData]="false"
  (loadMore)="(undefined)"
  [data]="processDataTransformation"
  (headerClick)="changeSort($event)"
>
  <ng-template
    [extraClass]="['wa-table__cell--fit-right']"
    app-column
    let-detail
  >
    <div style="margin-left:10px">{{ detail.Year }}</div>
  </ng-template>
  <ng-template
    [extraClass]="['visibility--hide-desktop', 'color-group-record']"
    app-row-group
    let-detail
  >
    <div class="uppertext-black">{{ detail.Year }}</div>
  </ng-template>
  <ng-template
    [extraClass]="[isAll ? 'flex-view' : '', 'wa-table__cell--fit-left', 'hoverable']"
    app-column
    let-detail
  >

    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <ng-container *ngIf="detail.Stage_1.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >

        <ng-container *ngFor="let stage of detail.Stage_1">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>

      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_1">
          <div
            (mouseenter)="isHoverMatch($event, detail, '1')"
            *ngIf="(detail.index.toString() + '1') != isHoveredMatch"
          >
            <ng-container *ngIf="stage.Rnk; else empty">
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </ng-container>
          </div>
          <ng-container>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + '1')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

  </ng-template>
  <ng-template
    [extraClass]="[isAll ? 'flex-view' : '', 'wa-table__cell--fit-left', 'hoverable']"
    app-column
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <ng-container *ngIf="detail.Stage_2.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_2">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_2">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div
              (mouseenter)="isHoverMatch($event, detail, '2')"
              *ngIf="(detail.index.toString() + '2') != isHoveredMatch"
            >
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </div>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + '2')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

    </ng-container>
  </ng-template>
  <ng-template
    [extraClass]="[isAll ? 'flex-view' : '', 'wa-table__cell--fit-left', 'hoverable']"
    app-column
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <ng-container *ngIf="detail.Stage_3.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_3">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_3">
          <div
            (mouseenter)="isHoverMatch($event, detail, '3')"
            *ngIf="(detail.index.toString() + '3') != isHoveredMatch"
          >
            <ng-container *ngIf="stage.Rnk; else empty">
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </ng-container>
          </div>
          <div
            (mouseleave)="isNotHoverMatch($event, detail)"
            *ngIf="isHoveredMatch == (detail.index.toString() + '3')"
          >
            {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
          </div>
        </ng-container>
      </ng-container>

    </ng-container>
  </ng-template>
  <ng-template
    [extraClass]="[isAll ? 'flex-view' : '', 'wa-table__cell--fit-left', 'hoverable']"
    app-column
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <ng-container *ngIf="detail.Stage_4.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_4">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_4">
          <div
            (mouseenter)="isHoverMatch($event, detail, '4')"
            *ngIf="(detail.index.toString() + '4') != isHoveredMatch"
          >
            <ng-container *ngIf="stage.Rnk; else empty">
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </ng-container>
          </div>
          <div
            (mouseleave)="isNotHoverMatch($event, detail)"
            *ngIf="isHoveredMatch == (detail.index.toString() + '4')"
          >
            {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
          </div>
        </ng-container>
      </ng-container>

    </ng-container>
  </ng-template>
  <ng-template
    [extraClass]="[isAll ? 'flex-view' : '', 'wa-table__cell--fit-left', 'hoverable']"
    app-column
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <ng-container *ngIf="detail.Final.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Final">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Final">
          <div
            (mouseenter)="isHoverMatch($event, detail, 'final')"
            *ngIf="(detail.index.toString() + 'final') != isHoveredMatch"
          >
            <ng-container *ngIf="stage.Rnk; else empty">
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </ng-container>
          </div>
          <div
            (mouseleave)="isNotHoverMatch($event, detail)"
            *ngIf="isHoveredMatch == (detail.index.toString() + 'final')"
          >
            {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
  <ng-template
    [extraClass]="[]"
    app-column-responsive
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <div class="uppertext-no-viewport">Stage 1</div>
    <ng-container *ngIf="detail.Stage_1.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_1">
          <ng-container *ngIf="stage.Rnk; else empty">

            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_1">

          <ng-container *ngIf="stage.Rnk; else empty">
            <div
              (mouseenter)="isHoverMatch($event, detail, '1')"
              *ngIf="(detail.index.toString() + '1') != isHoveredMatch"
            >
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </div>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + '1')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <div class="uppertext-no-viewport">Stage 2</div>
    <ng-container *ngIf="detail.Stage_2.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_2">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_2">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div
              (mouseenter)="isHoverMatch($event, detail, '2')"
              *ngIf="(detail.index.toString() + '2') != isHoveredMatch"
            >
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </div>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + '2')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

    </ng-container>
  </ng-template>
  <ng-template
    [extraClass]="[]"
    app-column-responsive
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <div class="uppertext-no-viewport">Stage 3</div>
    <ng-container *ngIf="detail.Stage_3.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_3">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_3">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div
              (mouseenter)="isHoverMatch($event, detail, '3')"
              *ngIf="(detail.index.toString() + '3') != isHoveredMatch"
            >
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </div>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + '3')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

    </ng-container>

    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <div class="uppertext-no-viewport">Stage 4</div>
    <ng-container *ngIf="detail.Stage_4.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Stage_4">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Stage_4">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div
              (mouseenter)="isHoverMatch($event, detail, '4')"
              *ngIf="(detail.index.toString() + '4') != isHoveredMatch"
            >
              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </div>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + '4')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

    </ng-container>
  </ng-template>
  <ng-template
    [extraClass]="[]"
    app-column-responsive
    let-detail
  >
    <ng-template #empty>
      <div>-</div>
    </ng-template>
    <div class="uppertext-no-viewport">Final</div>
    <ng-container *ngIf="detail.Final.length > 0; else empty">
      <div
        class="multiple-view"
        *ngIf="isAll == true"
      >
        <ng-container *ngFor="let stage of detail.Final">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
            <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>

            <ng-container *ngIf="stage.Rnk < 4">
              <div
                *ngIf="stage.Rnk === 1"
                class="position medal-gold"
              ></div>
              <div
                *ngIf="stage.Rnk === 2"
                class="position medal-silver"
              ></div>
              <div
                *ngIf="stage.Rnk === 3"
                class="position medal-bronze"
              ></div>
            </ng-container>
          </ng-container>
          /
        </ng-container>
      </div>
      <ng-container *ngIf="isAll == false">
        <ng-container *ngFor="let stage of detail.Final">
          <ng-container *ngIf="stage.Rnk; else empty">
            <div
              (mouseenter)="isHoverMatch($event, detail, 'final')"
              *ngIf="(detail.index.toString() + 'final') != isHoveredMatch"
            >

              <div *ngIf="stage.Rnk > 8">{{ stage.Outcome }}</div>
              <div *ngIf="stage.Rnk < 9 && stage.Rnk > 3">{{ stage.Rnk }}th</div>
              <ng-container *ngIf="stage.Rnk < 4">
                <div
                  *ngIf="stage.Rnk === 1"
                  class="position medal-gold"
                ></div>
                <div
                  *ngIf="stage.Rnk === 2"
                  class="position medal-silver"
                ></div>
                <div
                  *ngIf="stage.Rnk === 3"
                  class="position medal-bronze"
                ></div>
              </ng-container>
            </div>
            <div
              (mouseleave)="isNotHoverMatch($event, detail)"
              *ngIf="isHoveredMatch == (detail.index.toString() + 'final')"
            >
              {{stage?.StageData?.Place}}, {{stage?.StageData?.CountryName}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</app-wa-table>
